var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharedLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 5.00001H5.00016C4.07969 5.00001 3.3335 5.7462 3.3335 6.66668V15C3.3335 15.9205 4.07969 16.6667 5.00016 16.6667H13.3335C14.254 16.6667 15.0002 15.9205 15.0002 15V11.6667M11.6668 3.33334H16.6668M16.6668 3.33334V8.33334M16.6668 3.33334L8.3335 11.6667",
    stroke: "#8F9BBA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedLink);
export default __webpack_public_path__ + "static/media/shared-link.2ff91fc1b60aebd18c3b0aa6f681bc52.svg";
export { ForwardRef as ReactComponent };